import { Injectable } from "@angular/core";

import { ToastrService, IndividualConfig } from "ngx-toastr";

import { NotificationService } from "./notification.service";

@Injectable({
  providedIn: "root",
})
export class AppNotificationService implements NotificationService {
  constructor(private readonly toastr: ToastrService) {}

  success(message: string, title = "Succès"): void {
    this.toastr.success(message, title, this.centerConfig());
  }

  error(message: string, title = "Erreur"): void {
    this.toastr.error(message, title, this.centerConfig());
  }

  warning(message: string, title = "Attention"): void {
    this.toastr.warning(message, title, this.centerConfig());
  }

  info(message: string, title = "Information"): void {
    this.toastr.info(message, title, this.topRightConfig());
  }

  private centerConfig(): Partial<IndividualConfig> {
    return {
      positionClass: "toast-center-center",
      timeOut: 3000,
      closeButton: true,
      progressBar: true,
    };
  }

  private topRightConfig(): Partial<IndividualConfig> {
    return {
      positionClass: "toast-top-right",
      timeOut: 3000,
      closeButton: true,
      progressBar: true,
    };
  }
}
